<template>
  <AppHeader>Crate Summary</AppHeader>

  <FromToDate @filter="getData"></FromToDate>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="responsive-table" v-if="data.length != 0">
      <table>
        <thead>
          <tr>
            <th rowspan="2">Date</th>
            <th colspan="2">1L</th>
            <th colspan="2">500ml</th>
            <th colspan="2">Old Crates</th>
          </tr>
          <tr>
            <th>Sent</th>
            <th>Returned</th>
            <th>Sent</th>
            <th>Returned</th>
            <th>Sent</th>
            <th>Returned</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>Total</b></td>
            <td><b>{{ total['1l'].sent }}</b></td>
            <td><b>{{ total['1l'].returned }}</b></td>
            <td><b>{{ total['500ml'].sent }}</b></td>
            <td><b>{{ total['500ml'].returned }}</b></td>
            <td><b>{{ total.sent }}</b></td>
            <td><b>{{ total.returned }}</b></td>
          </tr>
          <tr v-for="date in data" :key="date.date">
            <td>{{ toDate(date.date) }}</td>
            <td>{{ date.crates ? date.crates['1l'].sent : null }}</td>
            <td>{{ date.crates ? date.crates['1l'].returned : null }}</td>
            <td>{{ date.crates ? date.crates['500ml'].sent : null }}</td>
            <td>{{ date.crates ? date.crates['500ml'].returned : null }}</td>
            <td>{{ date.sent_crate }}</td>
            <td>{{ date.returned_crate }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="text-center text-gray-500" v-else>
      <p>Please select From & To date to filter</p>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import FromToDate from '@/components/common/FromToDate.vue';

export default {
  name: 'ReportCrateSummary',
  mixins: [ mixin ],
  components: { AppHeader, Loading, FromToDate },
  data() {
    return {
      state: 'idle',
      data: [],
      total: {},
    }
  },

  methods: {
    getData(from, to) {
      this.state = 'loading';

      this.request('GET', 'reports/crate-summary?from=' + from + '&to=' + to, {}, (resp) => {
        this.state = 'idle';
        if (resp.success) this.calculateTotal(resp.data);
        else alert(resp.message);
      });
    },

    calculateTotal(data) {
      let total = {returned: 0, sent: 0, '1l': {sent: 0, returned: 0}, '500ml': {sent: 0, returned: 0}};

      data.forEach(entry => {
        total['returned'] += entry['returned_crate'];
        total['sent'] += entry['sent_crate'];

        total['1l']['sent'] += entry.crates ? Number(entry.crates['1l'].sent) : 0;
        total['1l']['returned'] += entry.crates ? Number(entry.crates['1l'].returned) : 0;
        total['500ml']['sent'] += entry.crates ? Number(entry.crates['500ml'].sent) : 0;
        total['500ml']['returned'] += entry.crates ? Number(entry.crates['500ml'].returned) : 0;
      });

      this.data = data;
      this.total = total;
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
  }
}
</script>
